import { EnumUtilities } from "../../../utilities/enum-utilities";
import {
    NotificationClientService,
    NotificationModel,
    NotificationType
} from "../../../services/basics/notification-client.service";
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerbale from "linq";
import { customElement } from "aurelia-framework";

@autoinject
@transient()
@customElement("notification")
export class Notification {

    constructor(notificationService: NotificationClientService) {
        notificationService.subscribeShow((model) => {
            if (!Enumerbale.from(this.notificationModels).any(x => x.title === model.title && x.description === model.description)) {
                this.notificationModels.push(model);
                if (model.time > 0) {
                    setTimeout(() => {
                        this.close(model);
                    }, model.time)
                }
            }
        });
    }

    notificationModels: NotificationModel[] = [];

    close(model: NotificationModel) {
        if (this.notificationModels.indexOf(model) < 0) {
            return;
        }

        model.isHidden = true;
        setTimeout(() => {
            this.notificationModels.splice(this.notificationModels.indexOf(model), 1);
        }, 300);
    }

    performAssignedAction(model: NotificationModel) {
        if (model.actionHandler)
            model.actionHandler(null);
    }

    public getEnumName(type: NotificationType): string {
        const name: string = EnumUtilities.getName(NotificationType, type);
        return name ? name.toLowerCase() : "";
    }
}
